import { useMemo } from 'react';

import { buildInitialState } from '../core/context-initial-state-builder.core';
import type { OptionInfo, ProductOptionConfig } from '../type/common.type';
import { reportProductOptionError } from '../util/executors/error-log-send-executor';

interface Props {
  option_info?: OptionInfo | null;
  config?: ProductOptionConfig;
}

export const useProductOptionHydrate = ({ option_info, config }: Props) => {
  const productId = option_info?.catalog_product?.id;

  const hydratedState = useMemo(() => {
    if (!option_info) {
      return null;
    }
    try {
      return buildInitialState(option_info, config);
    } catch (error) {
      reportProductOptionError({ message: 'Product option hydration failed', originalError: error });
      return null;
    }
  }, [productId]);

  return hydratedState;
};
